(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-accordion-instructions"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var accordion = document.getElementById('accordion');
    if (!accordion) return;

    var headers = [];
    Array.prototype.forEach.call(accordion.children, function (el) {
      if (el.tagName === 'H3') headers.push(el);
    });

    function panelFor(header) {
      return header.nextElementSibling;
    }

    headers.forEach(function (header) {
      header.classList.add('ui-accordion-header', 'ui-state-default');
      var panel = panelFor(header);
      if (panel) {
        panel.classList.add('ui-widget-content');
        panel.style.display = 'none';
      }
    });

    function closeAll() {
      headers.forEach(function (header) {
        header.classList.remove('ui-state-active');
        header.classList.add('ui-state-default');
        var panel = panelFor(header);
        if (panel) panel.style.display = 'none';
      });
    }

    function open(header) {
      closeAll();
      header.classList.remove('ui-state-default');
      header.classList.add('ui-state-active');
      var panel = panelFor(header);
      if (panel) panel.style.display = 'block';
    }

    headers.forEach(function (header) {
      header.addEventListener('click', function () {
        if (header.classList.contains('ui-state-active')) {
          closeAll();
        } else {
          open(header);
        }
      });
    });

    var hash = window.location.hash;
    if (hash) {
      var anchor = accordion.querySelector('a[href$="' + hash + '"]');
      if (anchor) {
        var header = anchor.closest('h3');
        if (header && headers.indexOf(header) > -1) open(header);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-accordion"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var accordion = document.getElementById('accordion');
    if (!accordion) return;

    var headers = [];
    Array.prototype.forEach.call(accordion.children, function (el) {
      if (el.tagName === 'H3') headers.push(el);
    });

    function panelFor(header) {
      return header.nextElementSibling;
    }

    headers.forEach(function (header) {
      header.classList.add('ui-accordion-header', 'ui-state-default');
      var panel = panelFor(header);
      if (panel) {
        panel.classList.add('ui-widget-content');
        panel.style.display = 'none';
      }
    });

    function closeAll() {
      headers.forEach(function (header) {
        header.classList.remove('ui-state-active');
        header.classList.add('ui-state-default');
        var panel = panelFor(header);
        if (panel) panel.style.display = 'none';
      });
    }

    function open(header) {
      closeAll();
      header.classList.remove('ui-state-default');
      header.classList.add('ui-state-active');
      var panel = panelFor(header);
      if (panel) panel.style.display = 'block';
    }

    headers.forEach(function (header) {
      header.addEventListener('click', function () {
        if (header.classList.contains('ui-state-active')) {
          closeAll();
        } else {
          open(header);
        }
      });
    });

    var hash = window.location.hash;
    if (hash) {
      var anchor = accordion.querySelector('a[href$="' + hash + '"]');
      if (anchor) {
        var header = anchor.closest('h3');
        if (header && headers.indexOf(header) > -1) open(header);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.contact-form-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        this.classList.toggle('btn-loading');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
